import { render } from "./events-activity.vue?vue&type=template&id=7dd5f4ec"
import script from "./events-activity.vue?vue&type=script&lang=js"
export * from "./events-activity.vue?vue&type=script&lang=js"

import "./events-activity.vue?vue&type=style&index=0&id=7dd5f4ec&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__